import * as React from 'react';
import * as styles from './styles.css';

interface IWrapperProps {
  children: React.ReactElement[];
  ref?: React.Ref<HTMLDivElement>;
}

export function PriceDynamicWrapper({ children, ref }: IWrapperProps): React.JSX.Element {
  return (
    <div ref={ref} className={styles['wrapper']}>
      {children}
    </div>
  );
}
